module.exports = __webpack_public_path__ + "img/08512037000100.7960fcba.png";